import styled from 'styled-components';
import DEVICES from '../../../common/styles/devices';
import { FONT_FAMILY } from '../../../common/styles/fontStyles';
import COLORS from '../../../common/styles/color-pallete';

export const RefferalCard = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .referralCard {
    width: 540px;
    background-color: ${COLORS.white};
    border-radius: 16px;
    padding: 32px 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 32px;
    box-shadow: 0px 10px 24px ${COLORS.boxLightShadow};
    overflow-wrap: anywhere;
  }
  .referDescription {
    max-width: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }

  .textDescription {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
  }

  .boldHead {
    text-align: center;
    font-size: 28px;
    line-height: 38px;
    font-family: ${FONT_FAMILY.hellix.bold};
  }
  .smallHead {
    text-align: center;
    font-size: 18px;
    line-height: 24px;
    font-weight: 400;
  }

  .workText {
    text-align: center;
    font-family: ${FONT_FAMILY.hellix.bold};
    cursor: pointer;
    font-size: 18px;
    line-height: 26px;
    background: none;
    border: none;
    outline: none;
    color: ${COLORS.darkBlue};
  }

  .rewardDescription {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
  }

  .promotionText {
    color: ${COLORS.textLightGrey};
    text-align: center;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
  }

  .rewardSummary {
    width: 400px;
    display: flex;
    flex-direction: column;
  }

  .refereeReward {
    display: flex;
    flex-direction: row;
    padding: 12px 16px 16px 16px;
    justify-content: space-between;
    align-items: center;
    border: 1px solid;
    border-color: ${COLORS.borderGrey};
    border-radius: 8px 8px 0px 0px;
    gap: 10px;
  }

  .referredReward {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 12px 16px 16px 16px;
    justify-content: space-between;
    border: 1px solid;
    border-width: 0 1px 0 1px;
    border-color: ${COLORS.borderGrey};
    gap: 10px;
  }
  .importantinfoCard {
    width: 400px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0 16px 16px 16px;
    border: 1px solid ${COLORS.borderGrey};
    border-width: 0 1px 1px 1px;
    border-radius: 0px 0px 8px 8px;

    span {
      margin-top: -2px;
    }

    @media ${DEVICES.mobileXL} {
      justify-content: center;
      width: 272px;
    }
  }
  .heading {
    font-size: 12px;
    line-height: 24px;
    font-family: ${FONT_FAMILY.hellix.regular};
    align-self: flex-start;
    color: ${COLORS.textLightGrey};

    @media ${DEVICES.mobileXL} {
      width: 272px;
    }
  }

  .leftReward {
    display: flex;
    align-items: baseline;
    flex-direction: column;
    width: 50%;
    text-align: left;
  }

  .rightReward {
    display: flex;
    flex-direction: column;
    align-items: end;
    width: 50%;
    text-align: right;
  }

  .amountBoldText {
    overflow-wrap: anywhere;
    line-height: 26px;
    font-family: ${FONT_FAMILY.hellix.bold};
    font-size: 18px;
  }

  .amountNormalText {
    overflow-wrap: anywhere;
    line-height: 18px;
    font-weight: 400;
    font-size: 14px;
  }

  .linkDescription {
    gap: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .referLink {
    width: 400px;
    gap: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .shareText {
    text-align: center;
    font-size: 14px;
    line-height: 26px;
    font-family: ${FONT_FAMILY.hellix.bold};
  }

  .linkBox {
    width: 100%;
    height: 72px;
    border-radius: 8px;
    border: 1px solid;
    padding: 24px;
    gap: 12px;
    display: flex;
    flex-direction: row;
    align-items: center;
    border-color: ${COLORS.borderGrey};
  }

  .inviteLink {
    width: 276px;
    height: 22px;
    font-size: 16px;
    line-height: 22px;
    font-weight: 400;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .sharedApps {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 12px;
  }

  .iconButton {
    cursor: pointer;
    width: auto;
    height: auto;
    border: none;
    background-color: ${COLORS.white};
    padding: 0;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
  }

  .termsConditions {
    text-align: center;
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
    align-items: center;
  }
  .linkText {
    cursor: pointer;
    font-family: ${FONT_FAMILY.hellix.bold};
    color: ${COLORS.darkBlue};
  }
  .qrButton {
    display: none;
  }
  .qrIcon {
    max-width: 24px;
    max-height: 25px;
  }

  @media ${DEVICES.mobileXL} {
    .referralCard {
      width: 90%;
    }
    .rewardSummary,
    .referLink {
      width: 272px;
    }
    .qrButton {
      cursor: pointer;
      outline: none;
      border: none;
      display: block;
      padding: 0;
    }
  }
`;
export const ImportantInfoSection = styled.li<{ $showDot?: boolean }>`
  list-style-type: ${({ $showDot }) => ($showDot ? 'disc' : 'none')};

  .icon {
    width: 16px;
    height: 16px;
    margin-right: 8px;
  }
  .text {
    display: flex;
    align-items: flex-start;
    font-size: 12px;
    line-height: 22px;
    font-family: ${FONT_FAMILY.hellix.regular};
    text-align: left;
  }
`;
export const List = styled.ul`
  padding-left: 1.25rem;
  text-align: start;
`;
